import { getFileExtension } from 'helpers/helper_functions';
import { EXTENSION_BASED_MIMETYPES } from 'constants/DocumentDefaults';

export function areSomeFilesEmpty(files) {
  return files.some((file) => !file.size);
}

export function getFilesWithContentType(files) {
  return files.map((file) => {
    let next = file;
    if (
      !file?.type?.length &&
      file?.name &&
      getFileExtension(file.name) &&
      EXTENSION_BASED_MIMETYPES[getFileExtension(file.name)]
    ) {
      next = new File([file], file.name, {
        type: EXTENSION_BASED_MIMETYPES[getFileExtension(file.name)],
      });
    }
    // react-dropzone removed auto-attached `preview` URLs in v9+; restore it here
    // so consumers that render previews from `file.preview` keep working.
    if (next && !next.preview && typeof URL?.createObjectURL === 'function') {
      try {
        next.preview = URL.createObjectURL(next);
      } catch {
        // ignore (non-browser env)
      }
    }
    return next;
  });
}
